import React, { useCallback, useEffect, useMemo } from "react";
import Cookies from "js-cookie";
import { v4 as uuidV4 } from "uuid";
import { useSession } from "@clerk/clerk-react";
import { COOKIES, getCookieDomain } from "../cookies";
import { resetSegment } from "./segment";

export const SegmentUserHOC: React.FC = ({ children }) => {
  const cookies = Cookies.get();
  const userUUID = useMemo(() => Cookies.get(COOKIES.UUID), [cookies]);
  const session = useSession();

  const setUUID = useCallback(() => {
    Cookies.set(COOKIES.UUID, uuidV4(), {
      expires: 365,
      domain: getCookieDomain(),
    });
  }, []);

  useEffect(() => {
    const segmentUUID = JSON.parse(
      window.localStorage?.getItem(COOKIES.SEGMENT_UUID)
    ) as string;
    const segmentUserId = JSON.parse(
      window.localStorage?.getItem(COOKIES.SEGMENT_USER_ID)
    ) as string;

    if (!userUUID) {
      setUUID();
    } else if (
      (!session.isSignedIn && segmentUserId) ||
      userUUID !== segmentUUID
    ) {
      resetSegment(userUUID);
    }
  }, [cookies, session.isSignedIn]);

  return <>{children}</>;
};
